export const YOURCALL_OB_FLAGS = {
    EVENT: 'EVFLAG_YC',
};
